import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import EChallanLoader from "./component";

const mapStateToProps = ({
    eChallan: {
        settledChallanCount,
        factsData
    }
}) => ({
    settledChallanCount,
    factsData
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EChallanLoader);

